import { X } from '@phosphor-icons/react'
import React from 'react'

export default function ImageView(props) {

    const closeModal = ()=>{
        try{
            props.setImgModal({
                imgUrl : "",
                openModal : false
            })

        }catch(error){
            console.log(error)
        }
    }

  return (
          <div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-60 flex items-center justify-center z-[1001] overflow-hidden">
                <div className="popup-content bg-white p-6 rounded-lg text-sm flex flex-col gap-2 w-full md:w-[70%] lg:w-[50%]" style={{width:"90%",height :"90%"}}>

                    {/* Header */}
                    <div className="flex items-center justify-between">
                        {/* <h4> </h4> */}
                        <button
                            className="hover:bg-[#F2F7FF] p-1.5 border-[1.5px] rounded-md"
                            type="button" onClick={()=>closeModal()}
                        >
                            <X weight="bold" size={18} />
                        </button>
                    </div>

 
                    {/* Image Disply */}
                    <div className="w-full h-[70vh] flex items-center justify-center">
                        <img src={props?.imgModal?.imgUrl} className='w-full h-full object-contain' alt="" />
                    </div>


             
                </div>
            </div>
  )
}
